import { hasFullWebmSupport } from '@seb-platform/shared/utils/browser';

const VIDEO_FORMATS = ['mp4', 'webm', 'm4v'];

export function isVideo(src: string | undefined | null) {
  if (!src) {
    return false;
  }
  return VIDEO_FORMATS.some(format => src.endsWith(format));
}

export function isVideoWebm(src: string | undefined | null) {
  return src?.endsWith('webm');
}

export function getTransparentVideoSource(sources: (string | undefined | null)[] | undefined): string | undefined {
  const preferredSuffix = hasFullWebmSupport() ? 'webm' : 'mp4';

  if (Array.isArray(sources) && sources.length > 0) {
    return sources.find(source => source?.includes(preferredSuffix)) ?? undefined;
  }

  return undefined;
}

export function getIdFromYouTubeUrl(url: string): string | undefined {
  let regExp: RegExp;
  if (url.includes('youtu.be/')) {
    regExp = /youtu\.be\/([\w\d-]+)\??/;
  } else {
    regExp = /youtube\.com\/watch\?v=([\w\d-]+)[&#/]?.*/;
  }
  return url.match(regExp)?.[1];
}

export function getYouTubeThumbnailUrl(videoId: string) {
  return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
}
